export default __webpack_public_path__ + "img/allergy-sesame.d0388384d96ae76d053f71039b71b5ea.svg";